exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-type-option.disabled{filter:saturate(75%);opacity:.9;cursor:not-allowed!important}.form-group.multi-choice{min-height:380px}i.fas.fa-times{cursor:pointer}", ""]);

// exports
